import { Card, createTheme } from '@mantine/core';

export const theme = (isLionsTech: boolean) =>
	createTheme({
		primaryColor: isLionsTech ? 'teal' : 'blue',
		cursorType: 'pointer',
		fontFamily: 'Saira, sans-serif',
		components: {
			Card: Card.extend({
				defaultProps: {
					radius: 'lg',
				},
			}),
		},
	});
